import {IStrUpdateTagNamesBody} from '../hooks/str-tagging/useStrUpdateTagNames';
import {CreateSTR} from '../types/search-term-report/strTypes';
import apiClient from './index';

const version = '/v1';
const ecaEndpoint = (path: string) => `${version}/eca${path}`;

export const getSTR = (params?: string) => {
  return apiClient.get(ecaEndpoint(`/searchtermreports` + params));
};

export const createSTR = (
  fieldTemplateId: number,
  clientId: string,
  projectId: string,
  strData: CreateSTR
) => {
  return apiClient.put(
    ecaEndpoint(
      `/indexes/${fieldTemplateId}/searchtermreports/draft?clientId=${clientId}&projectId=${projectId}`
    ),
    strData
  );
};

export const deleteSTR = (
  clientId: string,
  projectId: string,
  strReportId: string,
  fieldTemplateId = 0
) => {
  return apiClient.delete(
    ecaEndpoint(
      `/indexes/${fieldTemplateId}/searchtermreports/${strReportId}?clientId=${clientId}&projectId=${projectId}`
    )
  );
};

export const finaliseSTR = (
  fieldTemplateId: number,
  clientId: string,
  projectId: string,
  strReportId: string
) => {
  return apiClient.post(
    ecaEndpoint(
      `/indexes/${fieldTemplateId}/searchtermreports/${strReportId}/finalize?clientId=${clientId}&projectId=${projectId}`
    )
  );
};

export const getSTRDetail = (
  fieldTemplateId: number,
  clientId: string,
  projectId: string,
  strReportId: string
) => {
  return apiClient.get(
    ecaEndpoint(
      `/indexes/${fieldTemplateId}/searchtermreports/${strReportId}?clientId=${clientId}&projectId=${projectId}`
    )
  );
};

export const validateTerms = (
  fieldTemplateId: number,
  clientId: string,
  projectId: string,
  requestBody: {
    terms: string[];
    RelationalGroupFieldList?: string[];
  }
) => {
  return apiClient.post(
    ecaEndpoint(
      `/indexes/${fieldTemplateId}/searchtermreports/terms/validate?clientId=${clientId}&projectId=${projectId}`
    ),
    requestBody
  );
};

export const updateTagNamesForSTR = (
  taggingType: string,
  params: string,
  requestBody: IStrUpdateTagNamesBody,
  fieldTemplateId: string,
  strReportId: string
) => {
  return apiClient.post(
    ecaEndpoint(
      `/indexes/${fieldTemplateId}/searchtermreports/${strReportId}/tagging/${taggingType}` +
        params
    ),
    requestBody
  );
};
